import { IconButton } from "@mui/material";
import { useMemo } from "react";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import styled from "styled-components";

type Props = {
  onClick: () => void;
  width: number;
  height: number;
  color?: 'white' | 'black'
};

const DeleteIcon = (props: Props) => {
  const components = useMemo(() => {
    return (
      <DeleteIconStyle className="delete-icon-wrapper">
        <IconButton
          onClick={() => {
            props.onClick();
          }}
          sx={{
            width: props.width,
            height: props.height,
          }}
        >
          <RemoveCircleIcon
            sx={{
              color: props.color || 'black',
              width: props.width,
              height: props.height,
            }}
          />
        </IconButton>
      </DeleteIconStyle>
    );
  }, [props]);
  return components;
};

export default DeleteIcon;

const DeleteIconStyle = styled.div``;
